import { Component, inject, LOCALE_ID, OnInit } from "@angular/core";
import { RouterModule } from "@angular/router";
import { MasterDataService } from "@app/master-data.service";
import { UiKitModule } from "@app/ui-kit.module";
import { CloudProjectDeleteModalComponent } from "@components/cloud-project-delete-modal/cloud-project-delete-modal.component";
import { ProjectService } from "@domain/project/project.service";
import { TemplateService } from "@domain/project/template/template.service";
import { UserService } from "@domain/user/user.service";
import { ModalService, ModalSize } from "@odx/angular/components/modal";
import { DocumentType, LegalInformationService } from "@pages/legal-information/legal-information.service";
import { map, Observable, shareReplay, switchMap } from "rxjs";

@Component({
  selector: "app-main-menu",
  imports: [UiKitModule, RouterModule],
  templateUrl: "./main-menu.component.html",
  styleUrl: "./main-menu.component.scss",
  standalone: true,
})
export class MainMenuComponent implements OnInit {
  private masterDataService = inject(MasterDataService);
  private modalService = inject(ModalService);
  private userService = inject(UserService);
  private projectService = inject(ProjectService);
  private templateService = inject(TemplateService);
  private LegalInformationService = inject(LegalInformationService);
  private locale = inject(LOCALE_ID);

  protected isReadOnlyUser$: Observable<boolean>;
  protected isNewProjectVisible$: Observable<boolean>;

  protected privacyUrl = "";
  protected imprintUrl = "";
  protected legalNoticeUrl = "";

  ngOnInit(): void {
    const lang = this.locale;
    this.privacyUrl = this.LegalInformationService.getLegalDocumentLink(lang, DocumentType.DATA_PRIVACY);
    this.imprintUrl = this.LegalInformationService.getLegalDocumentLink(lang, DocumentType.IMPRINT);
    this.legalNoticeUrl = this.LegalInformationService.getLegalDocumentLink(lang, DocumentType.LEGAL_NOTICE);
  }

  constructor() {
    const user$ = this.userService.user$.pipe(shareReplay(1));
    this.isReadOnlyUser$ = user$.pipe(map((user) => user.readOnlyAccess));
    this.isNewProjectVisible$ = user$.pipe(
      switchMap((user) => this.templateService.generateTemplate(user.scope!, user.country)),
      map((template) => {
        return template?.properties?.general?.mainMenu?.newProject?.visible ?? false;
      }),
    );
  }
  protected onClickRefresh() {
    this.masterDataService.refresh();
  }

  protected onClickDeleteFromCloud() {
    this.modalService.open(CloudProjectDeleteModalComponent, {
      interactiveBackdrop: false,
      size: ModalSize.LARGE,
    });
  }

  protected logOut() {
    this.projectService.logout();
  }
}
